import { render } from "./SupplierPackages.vue?vue&type=template&id=e0d1e7d2&ts=true"
import script from "./SupplierPackages.vue?vue&type=script&lang=ts"
export * from "./SupplierPackages.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__